import { LANG_FRENCH } from '@/constants';
import { getEnvVar } from '@/utils/env';
import { replaceAll } from '@/utils/stringUtils';

export function useClientCopyComposable(lang, currency = '$##,###.00##') {
  const formatHotelPromtion = (promotionList, indicator) => {
    if (!promotionList) {
      return '';
    }
    return promotionList.reduce((result, promotion) => {
      if (result) {
        return `${result} ${indicator || '|'} ${promotion.promotionCode}`;
      } else {
        return `${promotion.promotionCode}`;
      }
    }, '');
  };

  const renderFrTitleTable = (title: string, $t: any) => {
    if (lang === LANG_FRENCH) {
      const titleReplaceFirst = replaceAll(title, '-', ` ${$t('common.to_normal')} `);
      const titleReplaceSecond = replaceAll(titleReplaceFirst, 'child', ` ${$t('common.child').toLowerCase()} `);
      return replaceAll(titleReplaceSecond, 'and', $t('common.and_normal'));
    }
    return title;
  };

  const formatCurrency = (number) => {
    if (number === null || number === 0) {
      return lang === 'fr' ? 'S.0' : 'N/A';
    } else {
      const firstSplitIndex = currency.indexOf('#');
      const lastSplitIndex = currency.lastIndexOf('#');
      const prefix = currency.slice(0, firstSplitIndex);
      const suffix = currency.slice(lastSplitIndex + 1);
      const formattedNumber = new Intl.NumberFormat(lang, { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(number);
      return `${prefix}${formattedNumber}${suffix}`;
    }
  };

  const BASE_URL = getEnvVar('VITE_CDN_BASE_URL');
  const cruiseIcon = `${BASE_URL}/assets/images/cruise.png`;
  const whiteImage = `${BASE_URL}/assets/images/white-image.png`;
  const flightHotelImage = `${BASE_URL}/assets/images/flight-hotel.png`;
  const FlightTourImage = `${BASE_URL}/assets/images/flight-tour.png`;
  const flightImage = `${BASE_URL}/assets/images/flight.png`;
  const hotelImage = `${BASE_URL}/assets/images/hotel.jpg`;
  const semistarImage = `${BASE_URL}/assets/images/semistar.svg`;
  return {
    formatHotelPromtion,
    cruiseIcon,
    whiteImage,
    flightHotelImage,
    flightImage,
    hotelImage,
    semistarImage,
    FlightTourImage,
    renderFrTitleTable,
    formatCurrency
  };
}
